module.exports = new __parcel__URL__("chillify.bebc3894.png").toString();